import configStore from "./configStore";
import dataStore from "./dataStore";
import memoryStore from "./memoryStore";
import dragStore from "./dragStore";
import contextStore from "./contextStore";
import searchStore from "./searchStore";
import selectStore from "./selectStore";
import communicatorStore from "./communicatorStore";
import {toJS} from 'mobx';

class rootStore {
  configStore=null;
  dataStore=null;
  historyStore=null;
  toJS=toJS;
  onRowClick=()=>{};
  getRowClassName=()=>{ return ""; };

  constructor(initial) {
    this.configStore=new configStore(this);
    if(initial.useRouter) {
      this.configStore.useRouter=true;
    }
    this.dragStore=new dragStore(this);
    this.communicatorStore=new communicatorStore(this);
    this.memoryStore=new memoryStore(this,initial.local_memory, initial.use_local_saver?true:false);
    this.contextStore=new contextStore(this);
    this.searchStore=new searchStore(this);
    this.selectStore=new selectStore(this);
    window.elementCommunicator=this.communicatorStore;
    if(initial.config_route) {
      this.configStore.route = initial.config_route;
    }
    if(initial.config) {
      this.configStore.setConfig(initial.config);
    }
    if(initial.getRowClassName) {
      this.getRowClassName=(row)=>{
        return initial.getRowClassName(row);
      };
    }
    if(initial.onRowClick) {
      this.onRowClick=(row)=>{
        initial.onRowClick(row);
      }
    }
    if(initial.communicator) {
      initial.communicator((subscribeFunc)=>{
        this.communicatorStore.subscribe(subscribeFunc);
      }, (message)=>{
        this.communicatorStore.pushMessage(message);
      });
    }
    if(initial.actionsHandler) {
      this.configStore.actionsHandler = initial.actionsHandler;
    }
    this.dataStore=new dataStore(this);
  }

  getStores() {
    return {
      configStore: this.configStore,
      dataStore: this.dataStore,
      memoryStore: this.memoryStore,
      contextStore: this.contextStore,
      dragStore: this.dragStore,
      searchStore: this.searchStore,
      selectStore: this.selectStore,
      communicatorStore: this.communicatorStore,
    }
  }
}

export default rootStore;
